import { useState, useEffect } from "react";
import { homepageCTAHeadlines } from "../utils/homepageCTAHeadlines";

// Get headline based on time + events only (no weather)
function getHeadline(now) {
  const hour = now.getHours();
  const day = now.getDay();
  const month = now.getMonth();
  const date = now.getDate();

  // PRIORITY 1: Special Events
  for (const [key, event] of Object.entries(homepageCTAHeadlines.events)) {
    if (event.match(month, date)) {
      return event.headline;
    }
  }

  // PRIORITY 2: Extreme Times
  for (const [key, time] of Object.entries(
    homepageCTAHeadlines.extremeTimes
  )) {
    if (time.match(hour, day)) {
      return time.headline;
    }
  }

  // PRIORITY 3: Time + Day Combos
  for (const [key, combo] of Object.entries(
    homepageCTAHeadlines.timeDayCombos
  )) {
    if (combo.match(hour, day)) {
      return combo.headline;
    }
  }

  // PRIORITY 4: Default Fallback
  return homepageCTAHeadlines.default;
}

// Hook
export default function useHomepageCTA() {
  const [headline, setHeadline] = useState(homepageCTAHeadlines.default);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const now = new Date();
    const finalHeadline = getHeadline(now);
    setHeadline(finalHeadline);
    setLoading(false);
  }, []);

  return { headline, loading };
}
